"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountType;
(function (AccountType) {
    AccountType[AccountType["POINT"] = 1] = "POINT";
    AccountType[AccountType["CASH"] = 2] = "CASH";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AccountTransactionSource;
(function (AccountTransactionSource) {
    AccountTransactionSource[AccountTransactionSource["SLM"] = 0] = "SLM";
    AccountTransactionSource[AccountTransactionSource["CLOCK_IN"] = 1] = "CLOCK_IN";
    AccountTransactionSource[AccountTransactionSource["PAYMENT_INVOICE"] = 2] = "PAYMENT_INVOICE";
    AccountTransactionSource[AccountTransactionSource["CHECK_IN"] = 3] = "CHECK_IN";
    AccountTransactionSource[AccountTransactionSource["ACCOUNT_MERGE"] = 4] = "ACCOUNT_MERGE";
    AccountTransactionSource[AccountTransactionSource["REDPACK"] = 5] = "REDPACK";
    AccountTransactionSource[AccountTransactionSource["POINT_TRANSFER"] = 6] = "POINT_TRANSFER";
    AccountTransactionSource[AccountTransactionSource["ACTIVITY"] = 7] = "ACTIVITY";
})(AccountTransactionSource = exports.AccountTransactionSource || (exports.AccountTransactionSource = {}));
//# sourceMappingURL=userAccount.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/userAccount.js
// module id = 447
// module chunks = 0